package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.UIElement
import kotlin.jvm.JvmField
import kotlin.jvm.JvmStatic

/**
 * 属性绑定：把同一属性的 apply 与 read 配对登记到 [PropAppliers]。
 *
 * [reader] 可为 `null`，表示该属性仅支持写、不参与动画起点读取。
 */
data class PropBinding(
    @JvmField val applier: PropApplier,
    @JvmField val reader: PropReader?,
    /**
     * 该属性变化是否影响布局（FR-30 B1 push 式脏标记）：true 时 [PropAppliers.apply] 应用后标脏触发重排。
     * 默认 true（保守不漏失效）；明确仅视觉、不影响测量/排版的属性可后续显式传 false 以提升布局缓存命中率。
     */
    @JvmField val affectsLayout: Boolean = true,
) {
    fun read(el: UIElement<*>): Any? = reader?.read(el)

    companion object {
        @JvmStatic
        fun writeOnly(applier: PropApplier): PropBinding = PropBinding(applier, null)

        @JvmStatic
        fun of(applier: PropApplier, reader: PropReader?): PropBinding = PropBinding(applier, reader)
    }
}
